import { modelServices } from '@/app/shared/services/client-agent-service.js';
import { httpClient } from '@/app/shared/services/http-client/http-client.js';


export class VendorGroupService {
    initAddVendorGroup(callback) {
        return httpClient.get(modelServices.baseUrl + modelServices.getInventoryManagementServiceName("InitializeAddVendorGroup").URL).then(callback);
    }
    initUpdateVendorGroup(param, callback) {

        var url = modelServices.baseUrl + modelServices.getInventoryManagementServiceName("InitializeUpdateVendorGroup").URL;
        return httpClient.get(url, { params: param }).then(callback);
    }
    checkDuplication(param, callback) {
        var url = modelServices.baseUrl + modelServices.getInventoryManagementServiceName("CheckDuplication").URL;
        return httpClient.get(url, { params: param }).then(callback);
    }
    addVendorGroup(vendorGroupModel, callback) {
        var url = modelServices.baseUrl + modelServices.getInventoryManagementServiceName("AddVendorGroup").URL;
        const options = {
            url: url,
            method: 'POST',
            data: JSON.stringify(vendorGroupModel)
        };
        httpClient(options).then(callback);
    }
    updateVendorGroup(vendorGroupModel, callback) {
        var url = modelServices.baseUrl + modelServices.getInventoryManagementServiceName("UpdateVendorGroup").URL;
        const options = {
            url: url,
            method: 'POST',
            data: JSON.stringify(vendorGroupModel)
        };
        httpClient(options).then(callback);
    }
    getVendorGroup() {
        return modelServices.baseUrl + modelServices.getInventoryManagementOdataServiceName("getVendorGroup").URL;
    }
    isVendorGroupDeleted(param, callback) {
        var url = modelServices.baseUrl + modelServices.getInventoryManagementServiceName("IsVendorGroupDeleted").URL;
        return httpClient.get(url, { params: param }).then(callback);
    }
    deleteVendorGroup = (vendorGroupId, modifiedTS, callback) => {
        const url = modelServices.baseUrl + modelServices.getInventoryManagementServiceName("deleteVendorGroup").URL + "?vendorGroupId=" + vendorGroupId + "&modifiedTS=" + modifiedTS;
        httpClient.delete(url).then(callback);
    };
}

const vendorGroupService = new VendorGroupService();
export { vendorGroupService };